import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Select from "react-select";
import { numRegex } from "../../Const";
import { formatShortNumber, formatShortNumberTwo, minOptions, maxOptions, minAreaOption, maxAreaOption, onKeyDown } from "../CommonFun";
import { BiSlider } from "react-icons/bi";

export default function MoreFilters({ title, plchdlr, filterData, filterCallBack, filterReset }) {
    const [selectOptions, setSelectOptions] = useState(filterData);
    const [openMenu, setOpenMenu] = useState(null);
    const [errorFlag, setErrorFlag] = useState({
        type: "", // "price" | "area"
        text: "",
        valid: false,
    });
    const [minData, setMinData] = useState({ price: [], area: [] });
    const [maxData, setMaxData] = useState({ price: [], area: [] });

    /* ------------------ INIT OPTIONS ------------------ */
    useEffect(() => {
        setMinData({ price: minOptions, area: minAreaOption });
        setMaxData({ price: maxOptions, area: maxAreaOption });
    }, []);

    /* ------------------ SYNC PARENT FILTER ------------------ */
    useEffect(() => {
        setSelectOptions(filterData);
    }, [filterData]);

    /* ------------------ CHANGE HANDLER ------------------ */
    const handlePriceChange = (eOrValue, keyName) => {
        setOpenMenu(null);
        let value;
        let name;
        if (keyName) {
            value = eOrValue;
            name = keyName;
        } else {
            value = eOrValue.target.value;
            name = eOrValue.target.name;
        }
        const option = { ...selectOptions };
        if (value != 0) {
            if (/^0/.test(value)) value = value.replace(/^0+/, "");
            if (!numRegex.test(value)) return;
            option[name] = value;
            setSelectOptions(option);
        } else {
            option[name] = "";
            setSelectOptions(option);
        }
        /* -------- PRICE VALIDATION -------- */
        if (["minPrice", "maxPrice"].includes(name)) {
            if (option.minPrice && option.maxPrice) {
                if (Number(option.minPrice) > Number(option.maxPrice)) {
                    setErrorFlag({
                        type: "price",
                        text: "Maximum price should be greater than minimum price.",
                        valid: true,
                    });
                    return;
                }
            }
        }
        /* -------- AREA VALIDATION -------- */
        if (["minArea", "maxArea"].includes(name)) {
            if (option.minArea && option.maxArea) {
                if (Number(option.minArea) > Number(option.maxArea)) {
                    setErrorFlag({
                        type: "area",
                        text: "Maximum area should be greater than minimum area.",
                        valid: true,
                    });
                    return;
                }
            }
        }
        setErrorFlag({ type: "", text: "", valid: false });
        filterCallBack(option);
    };  
    /* ------------------ DONE ------------------ */
    const handleDone = () => {
        const { minPrice, maxPrice, minArea, maxArea } = selectOptions;
        let value = plchdlr;
        if (title === "Price" && (minPrice || maxPrice)) {
            value = `${minPrice ? formatShortNumberTwo(minPrice) : ""}${maxPrice ? ` - ${formatShortNumberTwo(maxPrice)}` : ""} AED`;
        }
        if (title === "Area" && (minArea || maxArea)) {
            value = `${minArea ? formatShortNumber(minArea) : ""}${maxArea ? ` - ${formatShortNumber(maxArea)}` : ""} sqft`;
        }
    };

    /* ------------------ RESET ------------------ */
    const handleRemove = () => {
        let option = selectOptions;
        option["minPrice"] ="";
        option["maxPrice"] = "";
        option["minArea"] ="";
        option["maxArea"] = "";
        setSelectOptions(option);
        filterCallBack(option);
        setErrorFlag({ type: "", text: "", valid: false });
        if (filterReset) filterReset();
    };

    return (
        <div className="filter-dropdown">
            <DropdownButton
                className="custom-dropdown dropdown-button hide-icon"
                title={
                    <>
                        More Filters <BiSlider />
                    </>
                }
            >
                {/* PRICE */}
                <h2 className="inpt_head">Price (AED)</h2>
                <div className="dropdown-grid dropdown-input">
                    <RangeInput
                        label="Minimum"
                        name="minPrice"
                        value={selectOptions.minPrice}
                        options={minData.price}
                        openMenu={openMenu}
                        setOpenMenu={setOpenMenu}
                        onChange={handlePriceChange}
                        plchdlr="0"
                    />
                    <RangeInput
                        label="Maximum"
                        name="maxPrice"
                        value={selectOptions.maxPrice}
                        options={maxData.price}
                        openMenu={openMenu}
                        setOpenMenu={setOpenMenu}
                        onChange={handlePriceChange}
                        plchdlr="any"
                        error={errorFlag.type === "price" ? errorFlag : null}
                    />
                </div>
                {/* AREA */}
                <h2 className="inpt_head">Area (sqft)</h2>
                <div className="dropdown-grid dropdown-input">
                    <RangeInput
                        label="Minimum"
                        name="minArea"
                        value={selectOptions.minArea}
                        options={minData.area}
                        openMenu={openMenu}
                        setOpenMenu={setOpenMenu}
                        onChange={handlePriceChange}
                        plchdlr="0"
                    />
                    <RangeInput
                        label="Maximum"
                        name="maxArea"
                        value={selectOptions.maxArea}
                        options={maxData.area}
                        openMenu={openMenu}
                        setOpenMenu={setOpenMenu}
                        onChange={handlePriceChange}
                        plchdlr="any"
                        error={errorFlag.type === "area" ? errorFlag : null}
                    />
                </div>
                <Dropdown.Item as="span" className="full-width">
                    {selectOptions.minPrice || selectOptions.maxPrice || selectOptions.minArea || selectOptions.maxArea ? (
                        <button
                            className="reset-button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleRemove();
                            }}
                        >
                            Reset
                        </button>
                    ) : (
                        <></>
                    )}
                    {!errorFlag.valid && (selectOptions.minPrice || selectOptions.maxPrice || selectOptions.minArea || selectOptions.maxArea) ? (
                        <button className="done-button" onClick={handleDone}>
                            Done
                        </button>
                    ) : (
                        <></>
                    )}
                </Dropdown.Item>
            </DropdownButton>
        </div>
    );
}

/* ------------------ RANGE INPUT ------------------ */
function RangeInput({ label, name, value, options, openMenu, setOpenMenu, onChange, plchdlr, error }) {
    return (
        <li className="mnly-item price-input-wrapper text-start">
            <label>{label}</label>
            <input
                type="number"
                className="dropdown-item"
                name={name}
                value={value || ""}
                onKeyDown={onKeyDown}
                onChange={onChange}
                onClick={() => setOpenMenu(openMenu === name ? null : name)}
                placeholder={plchdlr}
            />
            <Select
                classNamePrefix="custom-select"
                options={options}
                value={options.find((o) => o.value === Number(value)) || null}
                onChange={(selected) => onChange(selected.value, name)}
                menuIsOpen={openMenu === name}
                styles={{ control: (base) => ({ ...base, display: "none" }) }}
            />
            {error?.valid && (
                <div className="error_head">
                    <div className="msg_error">
                        <bdi>{error.text}</bdi>
                    </div>
                    <bdi className="error_footer" />
                </div>
            )}
        </li>
    );
}
